export default __webpack_public_path__ + "static/media/thirtyYard.c2a3d2bb.jpg";